module.exports = __webpack_public_path__ + "files/918cad75540cface84d2380cc828091a.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-2.png
// module id = 522
// module chunks = 76